import { Component, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { GlobalSidenavComponent } from '@shared/components/global-sidenav/global-sidenav.component';
import { GlobalNavbarComponent } from './shared/components/global-navbar/global-navbar.component';
import { UserService } from '@services/user.service';
import { PRIMENG_MODULES } from '@shared/primeng';
import { GlobalToolbarComponent } from '@shared/components/global-toolbar/global-toolbar.component';
import { VersionService } from '@services/version.service';
import { Carousel } from 'primeng/carousel';
import { LoadingService } from '@services/loading.service';
import { RegisteredMarkComponent } from './shared/components/registered-mark/registered-mark.component';

@Component({
	selector: 'app-root',
	imports: [
		CommonModule,
		RouterOutlet,
		GlobalSidenavComponent,
		GlobalNavbarComponent,
		GlobalToolbarComponent,
		RegisteredMarkComponent,
		...PRIMENG_MODULES,
	],
	templateUrl: './app.component.html',
	styleUrl: './app.component.scss',
})
export class AppComponent {
	private readonly version = inject(VersionService);
	private readonly loadingService = inject(LoadingService);
	public readonly userService = inject(UserService);
	public readonly router = inject(Router);

	constructor() {
		this.setPrimeNGconfigs();

		console.log({ url: this.router.url });
		this.version.listenVersion();

		this.loadingService.show();
	}

	public get isAuthUrl(): boolean {
		return ['/auth', '/onboarding'].includes(this.router.url);
	}

	private setPrimeNGconfigs(): void {
		Carousel.prototype.onTouchMove = (event) => {
			event.stopPropagation();
		};
	}
}
